import BrandedLoginLayout from '../../../../ui/Layout/Theme/BrandedLoginLayout';
import BrandedOnboardingLayout from '../../../../ui/Layout/Theme/BrandedOnboardingLayout';
import type { CommonLayouts } from '../../ThemeTypes';

import showOrHideElements from './showOrHideElements';

const layout: CommonLayouts = {
  LoginLayout: BrandedLoginLayout,
  OnboardingLayout: BrandedOnboardingLayout,
  showOrHideElements,
};

export default layout;
